(function(w) {

    w.Completude = Object.assign({},w.Completude, { AcfKgRdv : {}});

    jQuery(function() {
        // Click sur le bouton d'affichage des heures du matin
        $(".acf-rdv .btn-am").on('click',function(e) {
            e.preventDefault();        
            $(this).closest(".tap-bloc").find(".select").removeClass("select");
            $(this).addClass("select");
            
            Completude.AcfKgRdv.AfficheAmPm($(this).closest(".tap-bloc"));
            return false;        
        });
        // Click sur le bouton d'affichage des heures de l'apres midi
        $(".acf-rdv .btn-pm").on('click',function(e) {
            e.preventDefault();        
            $(this).closest(".tap-bloc").find(".select").removeClass("select");
            $(this).addClass("select");        
            Completude.AcfKgRdv.AfficheAmPm($(this).closest(".tap-bloc"));
            return false;
        });
        // Click sur le bouton d'affichage des du soir
        $(".acf-rdv .btn-soir").on('click',function(e) {
            e.preventDefault();        
            $(this).closest(".tap-bloc").find(".select").removeClass("select");
            $(this).addClass("select");        
            Completude.AcfKgRdv.AfficheAmPm($(this).closest(".tap-bloc"));
            return false;
        });

        // Clic sur le jour
        $(".acf-rdv .tap-bloc>label").on('click',function(e) {
            e.preventDefault();
            $(this).closest(".tap-bloc").toggleClass("expanded");        
        })

        // Clic sur "voir plus de jours" 
        $(".acf-rdv .voir-plus").on('click',function() {
            $(".acf-rdv .voir-plus").toggleClass("hide");
            $(".acf-rdv .voir-moins").toggleClass("hide");
            $(".acf-rdv .tap-bloc-plus").show();
        });

        // Clic sur "voir moins de jours"
        $(".acf-rdv .voir-moins").on('click',function() {
            $(".acf-rdv .voir-plus").toggleClass("hide");
            $(".acf-rdv .voir-moins").toggleClass("hide");
            $(".acf-rdv .tap-bloc-plus").hide();
        });

        // Clic sur le choix d'une heure
        // Ouverture de la popup de confirmation
        $(".am .enabled label,.pm .enabled label,.soir .enabled label").each(function(index,el) {
            $(el).magnificPopup(({
                items: {
                    src: '#confirm-rdv',
                    type: 'inline'
                }            
            }));
            $(el).on('mfpOpen',function(e) {
                var label = e.currentTarget;
                var input = $("#" + $(label).attr('for'));            
                w.Completude.AcfKgRdv.inputRendezvousSelected = input;                
                $("#confirm-rdv-content").html("Je valide mon rendez-vous téléphonique du</br><strong>"+ Completude.AcfKgRdv.GetDateRdv(input.val())+"</strong>");                       
            })        
        });


        //Referme la popup ( Clic sur Annuler)
        $("#confirm-rdv-annuler").on("click",function() {
            $.magnificPopup.close();
        })

        // Clic sur Valider de la popup de confimration
        $("#confirm-rdv-valider").on("click",function() {
            w.Completude.AcfKgRdv.inputRendezvousSelected.prop("checked",true);
            $.magnificPopup.close();
            Completude.AcfKgRdv.inputRendezvousSelected.closest("[data-acf-type=kg-rdv]").trigger('acf-field-type-rdv-validation-rdv');
        })

        $(".acf-rdv .tap-bloc").each(function(i,el) {
            Completude.AcfKgRdv.AfficheAmPm(el);
        });
    });
    
    /**
     * 
     * @returns Retourne la date de rendez-vous selectionnée sous forme de string
     */
    w.Completude.AcfKgRdv.GetDateRdv = function($date) {
        if ($date!==null) {
            var date = new Date($date);
            date.toLocaleDateString("fr");
            var stringdate = date.toLocaleDateString('fr-FR',{weekday: 'long',day :'2-digit', month:'long'})+ " à " + (date.toLocaleTimeString('fr-FR',{hour :'2-digit',minute:'2-digit'})).replace(':','h'); 
            return stringdate.charAt(0).toUpperCase() + stringdate.slice(1)
        }
        return null;
    }

    w.Completude.AcfKgRdv.AfficheAmPm= function(tapbloc) {
        var $btnAm = $(tapbloc).find(".btn-am");
        var $btnPm = $(tapbloc).find(".btn-pm");
        if ($($btnAm).hasClass("select")) {
            // On affiche le matin
            $(tapbloc).find(".am").show();
            $(tapbloc).find(".pm").hide();                        
            $(tapbloc).find(".soir").hide();
        } else if ($($btnPm).hasClass("select")) {
            //On affiche l'apres midi
            $(tapbloc).find(".am").hide();
            $(tapbloc).find(".pm").show();                        
            $(tapbloc).find(".soir").hide();
        } else {
            // On affiche le soir
            $(tapbloc).find(".am").hide();
            $(tapbloc).find(".pm").hide();                        
            $(tapbloc).find(".soir").show();
        }
      
    }

    

})(window);